import React, { useEffect, useState } from "react";
import Modalheader from "components/modal/components/header";
import useModal from "components/modal/useModal";

import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Multiform from "components/modal/dataModal/data/modaljustify/address/component/multiform";
import Button from "components/button";
import { CheckIcon } from "assets/icons";
import axios from "axios";
import { toast } from "react-toastify";
import usefetchdata from "hooks/usefetchdata";
import Footerbutton from "components/modal/dataModal/data/modaljustify/address/component/footer/footerbutton";
import UseContext from "hooks/useContext";
import LoadingButton from "components/button/loading.js";

const Proofaddress = () => {
    const { toggle } = useModal();
    const { tempWorkerData } = usefetchdata();
    const { language, refreshLoadWorker } = UseContext();
    const [check, setCheck] = useState(true);
    const [formIndex, setFormIndex] = useState(1);
    const [proof, setProof] = useState("");
    const [files, setFiles] = useState(false);
    const [attestation, setAttestation] = useState("");
    const [hostIdentity, setHostIdentity] = useState({ type: "", nationality: "", fileR: null, fileV: null });
    const [loading, setLoading] = useState(false);
    const [isModifying, setIsModifying] = useState(false);

    const hasAccommodationValidated = tempWorkerData?.accommodation_of_address?.validated && tempWorkerData.accommodation_of_address.validated !== "0";
    const hasHostIdentityValidated = tempWorkerData?.hostIdentity?.validated && tempWorkerData.hostIdentity.validated !== "0";

    const pAddressMulti =
        tempWorkerData?.proof_of_address?.validated === "1" &&
        hasAccommodationValidated &&
        tempWorkerData?.accommodation_of_address?.validated === "1" &&
        (!hasHostIdentityValidated || tempWorkerData?.hostIdentity?.validated === "1");

    const pAddressSingle = tempWorkerData?.proof_of_address?.validated === "1" && !hasAccommodationValidated;

    useEffect(() => {
        if (isModifying) {
            setFiles(false);
            return;
        }
        if (pAddressMulti && formIndex < 6) {
            setFormIndex(7);
            setFiles(true);
            setCheck(false);
        } else if (pAddressSingle && formIndex < 3) {
            setFormIndex(7);
            setFiles(true);
            setCheck(true);
        } else {
            setFiles(false);
        }
    }, [formIndex, tempWorkerData, isModifying]);

    const singleFile = async (data) => {
        try {
            setLoading(true);
            const token = localStorage.getItem("xsrfToken");
            const formData = new FormData();
            
            // Extraire le fichier du FormData reçu
            const file = data.get("file");
            formData.append("proofAddress", file);
            formData.append("token", token);

            await axios
                .post(
                    `${process.env.REACT_APP_API_URL}upload/files`,
                    formData
                )
                .then((res) => {
                    if (res.data && res.status === 201) {
                        // Vérifier si l'upload a réussi
                        const hasFailures = res.data.failures && res.data.failures.length > 0;
                        
                        if (hasFailures) {
                            toast.error("Un problème est survenu");
                        } else {
                        if (formIndex === 4) {
                            toast.success(
                                'Le document "Justificatif de domicile" est modifié.'
                            );
                            setFormIndex(3);
                            toggle();
                            refreshLoadWorker();
                        } else {
                            toast.success(
                                'Le document "Justificatif de domicile" est ajouté.'
                            );
                            toggle();
                            refreshLoadWorker();
                        }
                    }
                    } else {
                        toast.error("Un problème est survenu");
                    }
                })
                .catch((e) => {
                    setLoading(false);
                    toast.error(e.response?.data?.error || "Un problème est survenu");
                })
                .finally(() => {
                    setLoading(false);
                });
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    const multiFiles = async (proofFile, attestationFile, hostId) => {
        setLoading(true);
        const idToastLoad = toast.loading("Envoi des fichiers en cours");
        
        try {
            const token = localStorage.getItem("xsrfToken");
            const formData = new FormData();
            
            if (proofFile && proofFile !== "") {
                formData.append("proofAddress", proofFile);
            }
            if (attestationFile && attestationFile !== "") {
                formData.append("accommodationCertificate", attestationFile);
            }
            if (hostId?.fileR) {
                formData.append("hostIdentityR", hostId.fileR);
                if (hostId.type === "CNI" && hostId.fileV) {
                    formData.append("hostIdentityV", hostId.fileV);
                }
                formData.append("hostIdentityType", hostId.type);
            }
            formData.append("token", token);

            const result = await axios.post(
                `${process.env.REACT_APP_API_URL}upload/files`,
                formData
            );

            if (result.status === 201 && result.data) {
                // Vérifier si tous les fichiers ont été uploadés avec succès
                const hasFailures = result.data.failures && result.data.failures.length > 0;
                
                if (hasFailures) {
                    toast.update(idToastLoad, {
                        render: "Certains fichiers n'ont pas pu être téléchargés",
                        type: "error",
                        autoClose: 3000,
                        isLoading: false,
                    });
                } else {
            toast.update(idToastLoad, {
                render: "Fichiers uploadés",
                type: "success",
                autoClose: 3000,
                isLoading: false,
            });
            setProof("");
            setAttestation("");
            setHostIdentity({ type: "", nationality: "", fileR: null, fileV: null });
            refreshLoadWorker();
            toggle();
                }
        } else {
                toast.update(idToastLoad, {
                    render: "Erreur d'envoi des fichiers",
                    type: "error",
                    autoClose: 3000,
                    isLoading: false,
                });
            }
        } catch (error) {
            toast.update(idToastLoad, {
                render: error.response?.data?.error || "Erreur d'envoi des fichiers",
                type: "error",
                autoClose: 3000,
                isLoading: false,
            });
        } finally {
            setLoading(false);
        }
    };

    const handleCheck = (e) => {
        e.preventDefault();
        setCheck(!check);
    };

    const handleIndex = (e) => {
        e.preventDefault();

        const needsProof = (formIndex === 1 || formIndex === 2) && proof;
        const needsAttestation = (formIndex === 3 || formIndex === 4) && attestation;
        const needsHostIdentity = (formIndex === 5 || formIndex === 6) && hostIdentity.fileR;

        if (needsProof || needsAttestation || needsHostIdentity) {
            setFormIndex(formIndex + 1);
        } else {
            toast.warning("Veuillez importer un fichier");
        }
    };

    const handleSubmitSingle = async (e) => {
        e.preventDefault();
        if (proof !== "") {
            const token = localStorage.getItem("xsrfToken");
            const formData = new FormData();
            formData.append("file", proof);
            formData.append("token", token);
            await singleFile(formData);
        } else toast.warning("Veuillez télécharger un fichier");
    };

    const handleSubmitMultiSingle = async (e) => {
        if ((proof !== "" || attestation !== "" || hostIdentity.fileR) && !files) {
            e.preventDefault();
            await multiFiles(proof, attestation, hostIdentity);
        } else {
            if (proof === '' && attestation === '' && !hostIdentity.fileR) return toggle();
            toast.warning("Veuillez télécharger les fichiers");
        }
    };

    const handleModifyAll = () => {
        setIsModifying(true);
        setProof("");
        setAttestation("");
        setHostIdentity({ type: "", nationality: "", fileR: null, fileV: null });
        setFormIndex(1);
    };

    return (
        <>
            <Modalheader hideShow={true} hide={toggle}>
                {language.getValue("justify.m_proof_title_c")}
            </Modalheader>
            <ModalBody>
                <Multiform
                    formIndex={formIndex}
                    setFormIndex={setFormIndex}
                    setProof={setProof}
                    proof={proof}
                    setAttestation={setAttestation}
                    attestation={attestation}
                    setCheck={setCheck}
                    check={check}
                    hostIdentity={hostIdentity}
                    setHostIdentity={setHostIdentity}
                    onModifyAll={handleModifyAll}
                />
                {formIndex !== 1 ? (
                    ""
                ) : (
                    <div className={" ft-sm mt-4 flex items-center gap-2 cursor-pointer"}
                        onClick={handleCheck}
                    >
                        <div className={`flex items-center justify-center h-4 w-4 border border-gray-300 rounded-sm bg-white ${check ? "bg-yellow-600 border-yellow-600" : ""} focus:outline-none transition duration-200`}>
                            {check ? (
                                <CheckIcon w={14} h={10} color={"#ffff"} />
                            ) : (
                                ""
                            )}
                        </div>
                        Le justificatif d’adresse est à mon nom
                    </div>
                )}
            </ModalBody>
            <ModalFooter>
                {loading ? (
                    <LoadingButton size={"LG"} />
                ) : (
                    <>
                        {formIndex === 7 ? (
                            <Button size={"LG"} onClick={toggle}>
                                Fermer
                            </Button>
                        ) : (
                            <>
                                {formIndex === 1 ? (
                                    <Button
                                        size={"LG"}
                                        color={"SECONDARY"}
                                        onClick={toggle}
                                    >
                                        Annuler
                                    </Button>
                                ) : (
                                    <Button
                                        size={"LG"}
                                        color={"SECONDARY"}
                                        onClick={() => setFormIndex(formIndex - 1)}
                                    >
                                        Précédent
                                    </Button>
                                )}

                                <Footerbutton
                                    formIndex={formIndex}
                                    check={check}
                                    oC1={handleIndex}
                                    oC2={handleSubmitMultiSingle}
                                    oC5={handleSubmitSingle}
                                />
                            </>
                        )}
                    </>
                )}
            </ModalFooter>
        </>
    );
};

export default Proofaddress;
